import { h } from 'preact';
import { LetterGrid } from './lettergrid';
import { Board, BoardPosition } from '../lib/wordboard';
import { Clue, ClueAnimation } from './clue';
import { VowelsApp } from './vowelsapp';

export interface HelpPageProps {
    vowelsApp: VowelsApp;
}

const exampleBoard:Board = {
    Rows: 4,
    Cols: 4,
    Letters: [
        ['R','T','Q','V'],
        ['P','N','L','Z'],
        ['H','P','M','S'],
        ['Y','W','X','F']
    ],
    Words: []
}

const exampleSelection:BoardPosition[] = [];
export function HelpPage({vowelsApp}: HelpPageProps) {
    
    return (
    <div class="help-page">
        <div class="title-section">
          <a class="back-button" onClick={()=>vowelsApp.navigateBack()}>&#8249;</a>
            <span>How To Play</span>
        </div>
        <div class="content-section">
          <div class="content-wrapper">
            
            
            
            <figure id="example-grid">
                <LetterGrid letters={exampleBoard.Letters} selectedLetters={exampleSelection}> 
                </LetterGrid>
                <figcaption>Fig 1.&nbsp;&nbsp;&nbsp;Word directions</figcaption>
            </figure>

            <p> Swipe up, down, left, right or diagonally on the consonants to complete the word shown in the clue.</p>

             <figure id="example-clue">
                <div class="clue-section">
                <Clue currentAnimation={ClueAnimation.None} word="  ue" selectedLetters={[]} onChangeClue={()=>{}}></Clue>
                </div>
                <figcaption>Fig 2.&nbsp;&nbsp;&nbsp;Clue and change arrows</figcaption>
            </figure>

            <p>If you get stuck you can use the arrows beside the clue to change it. Solve all of the clues to complete the level.</p>
            


          </div>
        </div>
    </div>
    )
}


